import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';

@Injectable()
export class BllMarkalar extends Database{
    eklenecek_markalar=[];

    constructor(){
        super("NL_Marka");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-markalar.ts